/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import { useToast } from "@/hooks/use-toast";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { z } from "zod";

type UseUserformType = {
  formData: any;
  onFormSubmit: (prop: any) => Promise<any>;
  open: boolean;
  onOpenChange: (prop: boolean) => void;
};

const formSchema = z.object({
  po_sku: z.string().optional(),
  erp_sku_code: z.any(),
  erp_sku_name: z.any(),
  erp_uom: z.any(),
  product_name: z.string().min(1, {
    message: "Product name is required.",
  }),
  retailer_id: z.string().min(1, {
    message: "Retailer name is required.",
  }),
});

export const useReactForm = ({
  formData,
  onFormSubmit,
  onOpenChange,
}: // open,
UseUserformType) => {
  // const { toast } = useToast();
  const schemaKeys = formSchema.keyof().options;

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "onBlur",
    defaultValues: {
      po_sku: "",
      erp_sku_code: "",
      retailer_id: "",
      product_name: "",
      erp_uom: "",
    },
  });

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      schemaKeys.forEach((key) => {
        if (formData[key]) {
          const value = formData[key];
          form.setValue(key, value, {
            shouldTouch: true,
            shouldDirty: true,
          });
        }
      });
    }
  }, [formData]);

  const updateErpSkuName = (prop: string) => {
    if (prop) {
      form.setValue("erp_sku_name", prop, {
        shouldTouch: true,
        shouldDirty: true,
      });
    }
  };
  const erpUomChange = (prop: any) => {
    console.log({ prop });
    if (prop?.erp_uom) {
      form.setValue("erp_uom", prop?.erp_uom, {
        shouldTouch: true,
        shouldDirty: true,
      });
    }
  };

  async function onSubmit(values: z.infer<typeof formSchema>) {
    const { data } = await onFormSubmit(values);
    if (data) {
      onOpenChange(false);
    }
  }

  return { form, onSubmit, updateErpSkuName, erpUomChange };
};
